import { Paper } from '@material-ui/core';
import type { CockpitRailSegment } from '../model/cockpitViewModel';
import { ActivityEvidenceRail } from './ActivityEvidenceRail';
import { CockpitSectionHead } from './CockpitSectionHead';
import { useCockpitStyles } from './cockpitStyles';

export interface CoverageSectionProps {
  rail: CockpitRailSegment[];
  selectedId: string | null;
  onSelect: (nodeId: string) => void;
}

/**
 * How much of this activity is actually proven is the first question the
 * cockpit exists to answer, so the coverage rail opens the page instead of
 * sitting inside the evidence flow, where it used to arrive third.
 */
export const CoverageSection = ({
  rail,
  selectedId,
  onSelect,
}: CoverageSectionProps) => {
  const classes = useCockpitStyles();
  return (
    <Paper
      component="section"
      className={classes.panelLead}
      aria-labelledby="coverage-title"
    >
      <CockpitSectionHead id="coverage-title" title="Cobertura da atividade">
        Largura proporcional à duração observada. Nada é presumido nos
        intervalos sem sinal.
      </CockpitSectionHead>
      <ActivityEvidenceRail
        segments={rail}
        selectedId={selectedId}
        onSelect={onSelect}
      />
    </Paper>
  );
};
